import { createSubmissionGate } from "../submission-gate";
import { showEditorSaved, focusEditorField } from "../editor-feedback";
import useMediaQuery from "Utils/hooks/use-media-query";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import {
  createNet,
  fetchDefaultsNets,
  updateNet,
  fetchLastUsedNets,
} from "Redux/middlwares/net";
import { fetchSteelDiameters } from "Redux/middlwares/steelType";
import { postMedia } from "Services/media";
import { calculate_partitions } from "../utils";
import NetMobileContent from "./mobile/content";
import {
  netXLengthMax,
  netXLengthMin,
  netYLengthMax,
  netYLengthMin,
  netXYLengthMax,
  netErrorTypes,
} from "Constants/net-constants";
import { STEEL_TYPES } from "Constants/general";
import NetSideBar from "./web/sidebar";
import SideBar from "../blocks/left-sidebar";
import SketchBody from "../blocks/sketch-body";
import NetShape from "./shape";
import LastAddedSidebar from "../blocks/right-sidebar";
import { setCurrentOrderNetsCount } from "Redux/features/net";
import NetsCard from "../blocks/right-sidebar/nets-cards/NetsCard";
import {
  getEditableTool,
  getNetCustomizeView,
  isUsableNetCatalogShape,
} from "../editor-data";

function Net({
  setLoader,
  handleClose,
  onSavingChange,
  edit,
  selectedTool,
  setSelectedTool,
  setIsStopped,
  tab,
  setTab,
  checkRowNums,
  editOrderId,
  editMode,
  deleteTool,
  copyOrderItem,
  setEditTool,
  order,
  editToolId,
}: any) {
  const isMobile = useMediaQuery("(max-width: 991.98px)");
  const isBrowser = !isMobile;
  const dispatch = useAppDispatch();
  const submission = useRef(createSubmissionGate());
  const savedItem = useRef<any>(null);
  const rememberSavedItem = (_ok: boolean, item?: any) => { savedItem.current = item; };
  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);
  const { t } = useTranslation(["tool"]);
  const stageRef = useRef(null);
  const finishButtonRef = useRef(null);
  const addButtonRef = useRef(null);
  const [netNumber, setNetNumber] = useState(0);
  const currentOrderNets = useAppSelector(
    (state) => state.net.currentOrderNets
  );
  const nextOrderNetsPage = useAppSelector((state) => state.net.orderNetPage);
  const standardShapes = useAppSelector((state) => state.net.defaultNets);
  const stanShapes = useAppSelector((state) => state.net.defaultShapes);
  const lastUsedShapes = useAppSelector((state) => state.net.lastUsedNets);
  const currentOrderNetsCount = useAppSelector(
    (state) => state.net.currentOrderNetsCount
  );
  const steelDiameters = useAppSelector(
    (state) => state.steelType.steelDiameters
  );

  const [partitionX, setPartitionX] = useState({
    _1: 10,
    _2: 10,
    _3: 20,
  });

  const [partitionY, setPartitionY] = useState({
    _1: 10,
    _2: 10,
    _3: 20,
  });
  const [labelingPoints, setLabelingPoints] = useState({
    topPtStart: { x: 0, y: 0 },
    topPtEnd: { x: 0, y: 0 },

    leftPtStart: { x: 0, y: 0 },
    leftPtEnd: { x: 0, y: 0 },

    bottomPtStart: { x: 0, y: 0 },
    bottomPtSecondLast: { x: 0, y: 0 },
    bottomPtEnd: { x: 0, y: 0 },

    rightPtStart: { x: 0, y: 0 },
    rightPtSecondLast: { x: 0, y: 0 },
    rightPtEnd: { x: 0, y: 0 },
  });
  const [resacleFactor, setRescaleFactor] = useState(1);
  const [selectedShape, setSelectedShape] = useState(-1); //To set the index of the selected item for styling while edit mode
  const [customizeView, setCustomizeView] = useState({
    uniformDiameter: true,
    uniformGap: true,
  });
  const [filterDiameter, setFilterDiameter] = useState({});
  const [filterGap, setFilterGap] = useState("");

  const [shapeObj, setShape] = useState({} as any);
  const [orderItem, setOrderItem] = useState({
    quantity: 0,
    production_notes: "",
    position_notes: "",
    row_number: 0,
  });
  const [errorsText, setErrorsText] = useState<any[]>([]);
  const [addMore, setAddMore] = useState(true);
  const [shapes, setShapes] = useState([]);
  const [stanGaps, setStanGaps] = useState([]);
  const [stanDiams, setStanDiams] = useState([]);
  const [isShapesError, setIsShapesError] = useState(false);

  // dummy states
  const [xUnits, setXUnits] = useState(0);
  const [yUnits, setYUnits] = useState(0);
  // dummy states ends

  const [netsData, setNetsData] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const [showStandard, setShowStandard] = useState(true);

  const [edgeChanged_X, setEdgeChanged_X] = useState(false);
  const [edgeChanged_Y, setEdgeChanged_Y] = useState(false);

  const [initiateImage, setInitiateImage] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const ignoreUnsavedChangesRef = useRef(true);

  const isDirtyRef = useRef(false);
  const resetAfterSuccessfulSaveRef = useRef(false);
  const requestCloseRef = useRef<() => void>(() => {});
  const showUnsavedWarningRef = useRef(false);

  const markAsChanged = () => {
  if (ignoreUnsavedChangesRef.current || isSaving) {
    return;
  }
  isDirtyRef.current = true;

  setHasUnsavedChanges(true);
  setSaveSucceeded(false);
};

  const handleSetShape = (value: any) => {
    markAsChanged();
    setShape(value);
  };

  const handleSetOrderItem = (value: any) => {
    markAsChanged();
    setOrderItem(value);
  };

  const handleSetPartitionX = (value: any) => {
    markAsChanged();
    setPartitionX(value);
  };

  const handleSetPartitionY = (value: any) => {
    markAsChanged();
    setPartitionY(value);
  };

  const handleSetFilterDiameter = (value: any) => {
    markAsChanged();
    setFilterDiameter(value);
  };

  const handleSetFilterGap = (value: any) => {
    markAsChanged();
    setFilterGap(value);
  };

  const handleSetSelectedShape = (value: any) => {
    markAsChanged();
    setSelectedShape(value);
  };

  const handleSetShowStandard = (value: any) => {
    markAsChanged();
    setShowStandard(value);
  };

  const handleSetEdgeChangedX = (value: any) => {
    markAsChanged();
    setEdgeChanged_X(value);
  };

  const handleSetEdgeChangedY = (value: any) => {
    markAsChanged();
    setEdgeChanged_Y(value);
  };

  const handleSetNetNumber = (value: any) => {
    markAsChanged();
    setNetNumber(value);
  };

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    onSavingChange?.(isSaving);
    return () => onSavingChange?.(false);
  }, [isSaving, onSavingChange]);
  const [saveSucceeded, setSaveSucceeded] = useState(false);
  const [showUnsavedWarning, setShowUnsavedWarning] = useState(false);
  const [showSaveErrorModal, setShowSaveErrorModal] = useState(false);
  const [saveErrorMessage, setSaveErrorMessage] = useState("");

  const toggleUniformGap = () => {
    markAsChanged();
    setCustomizeView({
      ...customizeView,
      uniformGap: !customizeView.uniformGap,
    });
  };
  const toggleUniformDiameter = () => {
    markAsChanged();
    setCustomizeView({
      ...customizeView,
      uniformDiameter: !customizeView.uniformDiameter,
    });
  };

  const addError = (newError: any) => {
    if (!errorsText.some((error) => error.errorType === newError.errorType)) {
      setErrorsText((prevErrors) => [...prevErrors, newError]);
    }
  };

  const removeError = (errorType: number) => {
    setErrorsText((prevErrors) =>
      prevErrors.filter((error) => error.errorType !== errorType)
    );
  };

  const checkLengths = () => {
    if (
      shapeObj.x_length < netXLengthMin ||
      shapeObj.y_length < netYLengthMin
    ) {
      addError({
        message: t("error_net_min", { ns: "tool" }),
        errorType: netErrorTypes.MIN,
      });
    }
    if (
      shapeObj.x_length >= netXLengthMax ||
      shapeObj.y_length >= netYLengthMax
    ) {
      addError({
        message: t("error_net_max", { ns: "tool" }),
        errorType: netErrorTypes.MAX,
      });
    }
    if (
      shapeObj.y_length > netXYLengthMax &&
      shapeObj.x_length > netXYLengthMax
    ) {
      addError({
        message: t("error_net_minmax", { ns: "tool" }),
        errorType: netErrorTypes.MAXMIN,
      });
    }
  };


  useEffect(() => {
  if (isLoading) return;

  const timeoutId = window.setTimeout(() => {
    ignoreUnsavedChangesRef.current = false;
    isDirtyRef.current = false;
    setHasUnsavedChanges(false);
    setSaveSucceeded(false);
  }, 100);

  return () => window.clearTimeout(timeoutId);
}, [isLoading, edit, selectedTool?.id]);


  useEffect(() => {
    if (currentOrderNets) {
      setNetsData(currentOrderNets);
      if (nextOrderNetsPage !== false) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    }
  }, [currentOrderNets]);

  useEffect(() => {
    const setShapeParams = async (shapeObject: any) => {
      if (!isUsableNetCatalogShape(shapeObject)) {
        addError({
          errorType: "INVALID_NET_DATA",
          message: t("invalid net data", { ns: "tool" }),
        });
        setIsLoading(false);
        return;
      }
      const nextCustomizeView = getNetCustomizeView(shapeObject);
      setCustomizeView(nextCustomizeView);
      setShowStandard(
        typeof shapeObject.standard_net === "boolean"
          ? shapeObject.standard_net
          : nextCustomizeView.uniformDiameter && nextCustomizeView.uniformGap
      );
      setFilterGap("");
      setFilterDiameter({});
      stanShapes.length === 0 && (await dispatch(fetchDefaultsNets()));
      if (shapeObject && stanShapes.length > 0) {
        setInitialShape(shapeObject);
        setShape({ ...shapeObject });
        setTimeout(() => {
          setIsLoading(false);
        }, 10);
        const selectedNet = stanShapes.find(
          (item) =>
            item.lens.x === parseInt(shapeObject.x_length) &&
            item.lens.y === parseInt(shapeObject.y_length)
        );
        if (selectedNet) {
          setStanGaps(selectedNet.gaps);
          setStanDiams(selectedNet.dia);
          const isDiaExist = selectedNet.dia.filter(
            (item) => item.id === shapeObject.x_diameter
          );
          const isGapExist = selectedNet.gaps.filter(
            (item) => item === shapeObject.x_gap
          );
          if (isGapExist && isDiaExist) {
            setFilterDiameter(shapeObject.x_diameter);
            setFilterGap(parseInt(isGapExist[0]));
          }
        }
      }
    };
    const editableTool = getEditableTool(edit, selectedTool);
    if (editableTool) {
      setSelectedShape(selectedTool.id);
      setShapeParams(editableTool);
      setOrderItem({
        quantity: selectedTool.quantity,
        production_notes: selectedTool.production_notes,
        position_notes: selectedTool.position_notes,
        row_number: selectedTool.row_number,
      });
    } else if (lastUsedShapes.length > 0 && selectedShape >= 0) {
      setShapeParams(lastUsedShapes[selectedShape]);
    }
  }, [selectedShape, edit, selectedTool, selectedTool?.tool, stanShapes.length]);

  useEffect(() => {
    STEEL_TYPES.forEach(st_type => {
      dispatch(fetchSteelDiameters(st_type));
    });
  }, []);

  useEffect(() => {
    const initalFetch = async () => {
      await dispatch(fetchLastUsedNets());
    };
    initalFetch();
  }, [dispatch, lastUsedShapes.length]);

  const setInitialShape = (shapeInstance: any) => {
    if (shapeInstance.x_2 === null && shapeInstance.x_3 === null) {
      const widthPartitions = calculate_partitions(
        shapeInstance.x_gap,
        shapeInstance.x_length,
        shapeInstance.x_diameter.steel_diameter
      );
      setPartitionX(widthPartitions);
    } else {
      setPartitionX({
        _1: shapeInstance.x_length - shapeInstance.x_2 - shapeInstance.x_3,
        _2: shapeInstance.x_2,
        _3: shapeInstance.x_3,
      });
    }
    if (shapeInstance.y_2 === null && shapeInstance.y_3 === null) {
      const heigthPartitions = calculate_partitions(
        shapeInstance.y_gap,
        shapeInstance.y_length,
        shapeInstance.y_diameter.steel_diameter
      );
      setPartitionY(heigthPartitions);
    } else {
      setPartitionY({
        _1: shapeInstance.y_length - shapeInstance.y_2 - shapeInstance.y_3,
        _2: shapeInstance.y_2,
        _3: shapeInstance.y_3,
      });
    }
  };

  useEffect(() => {
    const initalFetch = async () => {
      setLoader(true);
      stanShapes.length === 0 && (await dispatch(fetchDefaultsNets()));
      setLoader(false);
    };
    initalFetch();

    let shapeInstance = {};
    if (stanShapes.length > 0 && standardShapes.length > 0) {
      setShapes(stanShapes);
      setStanGaps(stanShapes[0].gaps);
      setStanDiams(stanShapes[0].dia);

      if (!edit) {
        const initialDiam =
          stanShapes[0].dia.find((el) => el.steel_diameter === 8) ||
          stanShapes[0].dia[0];
        const initialGap =
          stanShapes[0].gaps.find((el) => el === 20) ||
          stanShapes[0].gaps[0];
        setFilterDiameter(initialDiam);
        setFilterGap(initialGap);
        shapeInstance = {
          ...standardShapes[0],
          standard_net: true,
          x_length: parseInt(stanShapes[0].lens.x),
          y_length: parseInt(stanShapes[0].lens.y),
          x_diameter: initialDiam,
          y_diameter: initialDiam,
          x_gap: parseInt(initialGap),
          y_gap: parseInt(initialGap),
          x_2: null,
          x_3: null,
          y_2: null,
          y_3: null,
        };
        setInitialShape(shapeInstance);
        setShape({ ...shapeInstance });
        setIsLoading(false);
      }
    }
  }, [dispatch, setLoader, standardShapes.length, stanShapes.length]);

  useEffect(() => {
    const calculateWeight = () => {
      if (shapeObj.x_length && shapeObj.y_length) {
        const nx = Math.round(partitionX._1 / shapeObj.x_gap + 1);
        const lx = nx * shapeObj.y_length;
        const qx = (lx / 100) * parseFloat(shapeObj.x_diameter.weight);

        const ny = Math.round(partitionY._1 / shapeObj.y_gap + 1);
        const ly = ny * shapeObj.x_length;
        const qy = (ly / 100) * parseFloat(shapeObj.y_diameter.weight);
        const unitWeight = (qx + qy).toFixed(2);

        setShape((prev: any) => ({ ...prev, unit_weight: unitWeight }));
      }
    };

    if (shapeObj.x_diameter && shapeObj.y_diameter) {
      calculateWeight();
    }
  }, [
    shapeObj.x_diameter,
    shapeObj.y_diameter,
    shapeObj.x_gap,
    shapeObj.y_gap,
    shapeObj.y_length,
    shapeObj.x_length,
    partitionX._1,
    partitionY._1,
  ]);

  const validateMidVals = (
    val: number,
    maxVal: number,
    diam: number,
    partRemaining: number,
    partition: any
  ) => {
    const minOtherVals = (diam / 10) * 2 * 2;
    const p2 = parseInt(partRemaining) + parseInt(partition._2);
    const p3 = parseInt(partRemaining) + parseInt(partition._3);
    const sum = Math.abs(val) + Math.abs(p2) + Math.abs(p3);

    const flags = {
      otherChecks: false,
    };

    if (val > maxVal) {
      flags.otherChecks = true;
    }

    if (val + minOtherVals > maxVal) {
      flags.otherChecks = true;
    }

    if (sum > maxVal + 1) {
      flags.otherChecks = true;
    }
    return flags;
  };

  const validateVals = (
    val: number,
    diff: number,
    diam: number,
    otherP: number,
    maxLength: number
  ) => {
    let flags = {
      minValFlag: false,
      otherChecks: false,
      isError: false,
      isMax: false,
    };
    const minVal = (diam / 10) * 2;

    if (val < minVal || isNaN(val)) {
      flags.minValFlag = true;
      flags.isError = true;
    }
    if (Math.abs(val) + Math.abs(otherP) >= maxLength) {
      flags.otherChecks = true;
      flags.isError = true;
      flags.isMax = true;
    }
    if (val > maxLength) {
      flags.otherChecks = true;
      flags.isError = true;
      flags.isMax = true;
    }
    return flags;
  };

  const onX1Change = (e) => {
    markAsChanged();
    const val = parseInt(e.target.value);
    const partionsRemaining = (partitionX._1 - parseInt(e.target.value)) / 2;
    const checkFlags = validateMidVals(
      val,
      shapeObj.x_length,
      shapeObj.x_diameter.steel_diameter,
      partionsRemaining,
      partitionX
    );
    if (val > 0 && !checkFlags.otherChecks) {
      setPartitionX({
        _1: val,
        _2: partitionX._2 + partionsRemaining,
        _3: partitionX._3 + partionsRemaining,
      });
    }

    if (checkFlags.otherChecks) {
      addError({
        errorType: netErrorTypes._X1,
        message: t("error_net_measure", { ns: "tool" }),
      });
    } 
    if (
      val % shapeObj.x_gap !== 0 &&
      partitionY._1 % shapeObj.y_gap !== 0
    ) {
      addError({
        errorType: netErrorTypes.GAP_X1Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else if (val % shapeObj.x_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_X1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.GAP_X1Y1_VALIDATION);
      removeError(netErrorTypes.GAP_X1_VALIDATION);
    }
  };

  const onX2Change = (e) => {
    markAsChanged();
    setEdgeChanged_X(true);
    const val = parseFloat(e.target.value);
    const diff = partitionX._2 - val;
    const flagChecks = validateVals(
      val,
      diff,
      shapeObj.x_diameter.steel_diameter,
      partitionX._3,
      shapeObj.x_length
    );

    const partX1Val =
      flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
        ? shapeObj.x_length - (isNaN(partitionX._3) ? 0 : partitionX._3)
        : shapeObj.x_length - (isNaN(partitionX._3) ? 0 : partitionX._3) - val;

    if (val > 0 && !flagChecks.otherChecks) {
      setPartitionX({
        ...partitionX,
        _2: e.target.value === "" ? 0 : val,
        _1:
          e.target.value === ""
            ? shapeObj.x_length - (isNaN(partitionX._3) ? 0 : partitionX._3)
            : shapeObj.x_length -
              (isNaN(partitionX._3) ? 0 : partitionX._3) -
              val,
      });
    } else if (!flagChecks.isMax) {
      setPartitionX({
        ...partitionX,
        _1:
          flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
            ? shapeObj.x_length - (isNaN(partitionX._3) ? 0 : partitionX._3)
            : shapeObj.x_length -
              (isNaN(partitionX._3) ? 0 : partitionX._3) -
              val,
        _2: "",
      });
    }
    if (flagChecks.otherChecks || isNaN(val) || val === 0) {
      addError({
        errorType: netErrorTypes._X2,
        message: t("error_net_measure", { ns: "tool" }),
      });
    }
    else{
      removeError(netErrorTypes._X2);
    }
    if (flagChecks.minValFlag) {
      addError({
        errorType: netErrorTypes.MIN_X2PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.MIN_X2PART);
    }
    if (
      partX1Val % shapeObj.x_gap !== 0 &&
      partitionY._1 % shapeObj.y_gap !== 0
    ) {
      addError({
        errorType: netErrorTypes.GAP_X1Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else if (partX1Val % shapeObj.x_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_X1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.GAP_X1Y1_VALIDATION);
      removeError(netErrorTypes.GAP_X1_VALIDATION);
    }
  };

  const onX3Change = (e) => {
    markAsChanged();
    setEdgeChanged_X(true);
    const val = parseFloat(e.target.value);
    const diff = partitionX._3 - val;
    const flagChecks = validateVals(
      val,
      diff,
      shapeObj.x_diameter.steel_diameter,
      partitionX._2,
      shapeObj.x_length
    );

    const partX1Val =
      flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
        ? shapeObj.x_length - (isNaN(partitionX._2) ? 0 : partitionX._2)
        : shapeObj.x_length - (isNaN(partitionX._2) ? 0 : partitionX._2) - val;
    if (val > 0 && !flagChecks.otherChecks) {
      setPartitionX({
        ...partitionX,
        _3: e.target.value === "" ? 0 : val,
        _1:
          e.target.value === ""
            ? shapeObj.x_length - (isNaN(partitionX._2) ? 0 : partitionX._2)
            : shapeObj.x_length -
              (isNaN(partitionX._2) ? 0 : partitionX._2) -
              val,
      });
    } else if (!flagChecks.isMax) {
      setPartitionX({
        ...partitionX,
        _1:
          flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
            ? shapeObj.x_length - (isNaN(partitionX._2) ? 0 : partitionX._2)
            : shapeObj.x_length -
              (isNaN(partitionX._2) ? 0 : partitionX._2) -
              val,
        _3: "",
      });
    }
    if (flagChecks.otherChecks || isNaN(val) || val === 0) {
      addError({
        errorType: netErrorTypes._X3,
        message: t("error_net_measure", { ns: "tool" }),
      });
    }
    else{
      removeError(netErrorTypes._X3);
    }
    if (flagChecks.minValFlag) {
      addError({
        errorType: netErrorTypes.MIN_X3PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.MIN_X3PART);
    }
    if (
      partX1Val % shapeObj.x_gap !== 0 &&
      partitionY._1 % shapeObj.y_gap !== 0
    ) {
      addError({
        errorType: netErrorTypes.GAP_X1Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else if (partX1Val % shapeObj.x_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_X1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.GAP_X1Y1_VALIDATION);
      removeError(netErrorTypes.GAP_X1_VALIDATION);
    } 
  };

  const onY1Change = (e) => {
    markAsChanged();
    const val = parseInt(e.target.value);
    const partionsRemaining = (partitionY._1 - parseInt(e.target.value)) / 2;
    const checkFlags = validateMidVals(
      val,
      shapeObj.y_length,
      shapeObj.y_diameter.steel_diameter,
      partionsRemaining,
      partitionY
    );

    if (val > 0 && !checkFlags.otherChecks) {
      setPartitionY({
        _1: val,
        _2: partitionY._2 + partionsRemaining,
        _3: partitionY._3 + partionsRemaining,
      });
    }

    if (checkFlags.otherChecks) {
      addError({
        errorType: netErrorTypes._Y1,
        message: t("error_net_measure", { ns: "tool" }),
      });
    } 
    if (
      val % shapeObj.y_gap !== 0 &&
      partitionX._1 % shapeObj.x_gap !== 0
    ) {
      addError({
        errorType: netErrorTypes.GAP_X1Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else if (val % shapeObj.y_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes._Y1);
      removeError(netErrorTypes.GAP_X1Y1_VALIDATION);
      removeError(netErrorTypes.GAP_Y1_VALIDATION);
    }
  };

  const onY2Change = (e) => {
    markAsChanged();
    setEdgeChanged_Y(true);
    const val = parseFloat(e.target.value);
    const diff = partitionY._2 - val;
    const flagChecks = validateVals(
      val,
      diff,
      shapeObj.y_diameter.steel_diameter,
      partitionY._3,
      shapeObj.y_length
    );

    const partYVal =
      flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
        ? shapeObj.y_length - (isNaN(partitionY._3) ? 0 : partitionY._3)
        : shapeObj.y_length - (isNaN(partitionY._3) ? 0 : partitionY._3) - val;

    if (val > 0 && !flagChecks.otherChecks) {
      setPartitionY({
        ...partitionY,
        _2: e.target.value === "" ? 0 : val,
        _1:
          e.target.value === ""
            ? shapeObj.y_length - (isNaN(partitionY._3) ? 0 : partitionY._3)
            : shapeObj.y_length -
              (isNaN(partitionY._3) ? 0 : partitionY._3) -
              val,
      });
    } else if (!flagChecks.isMax) {
      setPartitionY({
        ...partitionY,
        _1:
          flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
            ? shapeObj.y_length - (isNaN(partitionY._3) ? 0 : partitionY._3)
            : shapeObj.y_length -
              (isNaN(partitionY._3) ? 0 : partitionY._3) -
              val,
        _2: "",
      });
    }

    if (flagChecks.otherChecks || isNaN(val) || val === 0) {
      addError({
        errorType: netErrorTypes._Y2,
        message: t("error_net_measure", { ns: "tool" }),
      });
    }
    else{
      removeError(netErrorTypes._Y2);
    }

    if (flagChecks.minValFlag) {
      addError({
        errorType: netErrorTypes.MIN_Y2PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.MIN_Y2PART);
    }
    if (
      partYVal % shapeObj.y_gap !== 0 &&
      partitionX._1 % shapeObj.x_gap !== 0
    ) {
      addError({
        errorType: netErrorTypes.GAP_X1Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else if (partYVal % shapeObj.y_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.GAP_X1Y1_VALIDATION);
      removeError(netErrorTypes.GAP_Y1_VALIDATION);
    }
  };

  const onY3Change = (e) => {
    markAsChanged();
    setEdgeChanged_Y(true);
    const val = parseFloat(e.target.value);
    const diff = partitionY._3 - val;
    const flagChecks = validateVals(
      val,
      diff,
      shapeObj.y_diameter.steel_diameter,
      partitionY._2,
      shapeObj.y_length
    );

    const partYVal =
      flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
        ? shapeObj.y_length - (isNaN(partitionY._2) ? 0 : partitionY._2)
        : shapeObj.y_length - (isNaN(partitionY._2) ? 0 : partitionY._2) - val;

    if (val > 0 && !flagChecks.otherChecks) {
      setPartitionY({
        ...partitionY,
        _3: e.target.value === "" ? 0 : val,
        _1:
          e.target.value === ""
            ? shapeObj.y_length - (isNaN(partitionY._2) ? 0 : partitionY._2)
            : shapeObj.y_length -
              (isNaN(partitionY._2) ? 0 : partitionY._2) -
              val,
      });
    } else if (!flagChecks.isMax) {
      setPartitionY({
        ...partitionY,
        _1:
          flagChecks.isError || isNaN(e.target.value) || e.target.value === ""
            ? shapeObj.y_length - (isNaN(partitionY._2) ? 0 : partitionY._2)
            : shapeObj.y_length -
              (isNaN(partitionY._2) ? 0 : partitionY._2) -
              val,
        _3: "",
      });
    }
    if (flagChecks.otherChecks || isNaN(val) || val === 0) {
      addError({
        errorType: netErrorTypes._Y3,
        message: t("error_net_measure", { ns: "tool" }),
      });
    }
    else{
      removeError(netErrorTypes._Y3);
    }
    if (flagChecks.minValFlag) {
      addError({
        errorType: netErrorTypes.MIN_Y3PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.MIN_Y3PART);
    }
    if (
      partYVal % shapeObj.y_gap !== 0 &&
      partitionX._1 % shapeObj.x_gap !== 0
    ) {
      addError({
        errorType: netErrorTypes.GAP_X1Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else if (partYVal % shapeObj.y_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
    } else {
      removeError(netErrorTypes.GAP_X1Y1_VALIDATION);
      removeError(netErrorTypes.GAP_Y1_VALIDATION);
    }
  };

  const requestClose = () => {
    if (isSaving) {
      return;
    }

    // The ref is the single source of truth. React state may still contain
    // the previous value for one render after a successful save.
    if (isDirtyRef.current || hasUnsavedChanges) {
  isDirtyRef.current = true;
  setHasUnsavedChanges(true);
  setShowUnsavedWarning(true);
  return;
}

    showUnsavedWarningRef.current = false;
    setShowUnsavedWarning(false);
    handleClose();
  };

requestCloseRef.current = requestClose;
showUnsavedWarningRef.current = showUnsavedWarning;
  /*
   * The main tool modal is rendered by a parent component, so its backdrop
   * does not call this component's requestClose directly. Capture clicks on
   * the visible Bootstrap modal backdrop/container before the parent closes it.
   */
  requestCloseRef.current = requestClose;
showUnsavedWarningRef.current = showUnsavedWarning;

useEffect(() => {
  const handleOutsideModalClick = (event: MouseEvent) => {
    if (showUnsavedWarningRef.current) return;

    const target = event.target;

    if (!(target instanceof HTMLElement)) return;

    // React-Bootstrap שולח לחיצה על הרקע דרך אלמנט ה-modal החיצוני.
    // אסור לתפוס לחיצות ששייכות למודאל אזהרת השינויים.
    const clickedModalSurface = target.classList.contains("modal");

    const belongsToWarningModal = Boolean(
      target.querySelector(".unsaved-warning-modal")
    );

    if (!clickedModalSurface || belongsToWarningModal) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    requestCloseRef.current();
  };

  const handleEscapeKey = (event: KeyboardEvent) => {
    if (
      event.key !== "Escape" ||
      showUnsavedWarningRef.current
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    requestCloseRef.current();
  };

  document.addEventListener(
    "click",
    handleOutsideModalClick,
    true
  );

  document.addEventListener(
    "keydown",
    handleEscapeKey,
    true
  );

  return () => {
    document.removeEventListener(
      "click",
      handleOutsideModalClick,
      true
    );

    document.removeEventListener(
      "keydown",
      handleEscapeKey,
      true
    );
  };
}, []);


  const continueEditing = () => {
    showUnsavedWarningRef.current = false;
    setShowUnsavedWarning(false);
  };

  const discardChangesAndClose = () => {
    ignoreUnsavedChangesRef.current = true;
    isDirtyRef.current = false;
    resetAfterSuccessfulSaveRef.current = false;
    showUnsavedWarningRef.current = false;
    setShowUnsavedWarning(false);
    setHasUnsavedChanges(false);
    setSaveSucceeded(false);
    handleClose();
  };

  function saveNet(isAddMore: boolean, netNum: number) {
    if (submission.current.pending) return;
    setAddMore(isAddMore);
    isDirtyRef.current = true;
    setHasUnsavedChanges(true);
    setSaveSucceeded(false);

    if (!orderItem.quantity) {
      focusEditorField("quantity");
      addError({
        message: t("error_net_amount", { ns: "tool" }),
        errorType: netErrorTypes.AMOUNT,
      });
      return;
    }

    if (
      shapeObj.x_length < netXLengthMin ||
      shapeObj.y_length < netYLengthMin
    ) {
      addError({
        message: t("error_net_min", { ns: "tool" }),
        errorType: netErrorTypes.MIN,
      });
      return;
    }

    if (
      shapeObj.x_length >= netXLengthMax ||
      shapeObj.y_length >= netYLengthMax
    ) {
      addError({
        message: t("error_net_max", { ns: "tool" }),
        errorType: netErrorTypes.MAX,
      });
      return;
    }

    if (
      shapeObj.y_length > netXYLengthMax &&
      shapeObj.x_length > netXYLengthMax
    ) {
      addError({
        message: t("error_net_minmax", { ns: "tool" }),
        errorType: netErrorTypes.MAXMIN,
      });
      return;
    }

    if (partitionX._2 < (shapeObj.x_diameter.steel_diameter / 10) * 2) {
      addError({
        errorType: netErrorTypes.MIN_X2PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
      return;
    } else if (
      partitionX._3 <
      (shapeObj.x_diameter.steel_diameter / 10) * 2
    ) {
      addError({
        errorType: netErrorTypes.MIN_X3PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
      return;
    } else if (
      partitionY._2 <
      (shapeObj.y_diameter.steel_diameter / 10) * 2
    ) {
      addError({
        errorType: netErrorTypes.MIN_Y2PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
      return;
    } else if (
      partitionY._3 <
      (shapeObj.y_diameter.steel_diameter / 10) * 2
    ) {
      addError({
        errorType: netErrorTypes.MIN_Y3PART,
        message: t("error_net_sides", { ns: "tool" }),
      });
      return;
    }

    if (partitionX._1 % shapeObj.x_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_X1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
      return;
    } else if (partitionY._1 % shapeObj.y_gap !== 0) {
      addError({
        errorType: netErrorTypes.GAP_Y1_VALIDATION,
        message: t("error_net_gap_xy", { ns: "tool" }),
      });
      return;
    }

    if (!stageRef.current) {
      addError({
        errorType: "PREVIEW_ERROR",
        message: t("preview net unavailable", { ns: "tool" }),
      });
      return;
    }

    ignoreUnsavedChangesRef.current = true;
    resetAfterSuccessfulSaveRef.current = false;
    if (!submission.current.begin()) return;
    setIsSaving(true);
    setInitiateImage(true);
    setIsStopped(false);

    const handleSaveFailure = (message: string) => {
  ignoreUnsavedChangesRef.current = false;
  isDirtyRef.current = true;
  resetAfterSuccessfulSaveRef.current = false;

  submission.current.end();

  setIsSaving(false);
  setInitiateImage(false);
  setSaveSucceeded(false);
  setHasUnsavedChanges(true);
  setIsStopped(true);

  setSaveErrorMessage(message);
  setShowSaveErrorModal(true);
};

    const completeSuccessfulSave = async () => {
      // Clear dirty state before resetting any form fields. The reset itself
      // must never be interpreted as a new user change.
      ignoreUnsavedChangesRef.current = true;
      isDirtyRef.current = false;
      resetAfterSuccessfulSaveRef.current = false;
      showUnsavedWarningRef.current = false;

      setShowUnsavedWarning(false);
      setHasUnsavedChanges(false);
      setSaveSucceeded(true);
      submission.current.end();
      setIsSaving(false);
      setInitiateImage(false);

      await setDefaultShape();

      if (stanShapes.length > 0) {
        setStanGaps(stanShapes[0].gaps);
        setStanDiams(stanShapes[0].dia);

        const initialDiam =
          stanShapes[0].dia.find((el) => el.steel_diameter === 8) ||
          stanShapes[0].dia[0];

        const initialGap =
          stanShapes[0].gaps.find((el) => el === 20) ||
          stanShapes[0].gaps[0];

        setFilterDiameter(initialDiam);
        setFilterGap(initialGap);
      }

      setOrderItem({
        quantity: 0,
        production_notes: "",
        position_notes: "",
        row_number: 0,
      });

      setIsStopped(true);

      showEditorSaved("net", savedItem.current?.id, edit, t, rightToLeft);
      if (isMobile || isAddMore === false || editToolId >= 0) {
        // Close directly after a confirmed successful save.
        handleClose();
        return;
      }

      // Allow all reset-related React updates to finish before tracking the
      // next item. The new blank item starts clean.
      window.setTimeout(() => {
        isDirtyRef.current = false;
        setHasUnsavedChanges(false);
        setSaveSucceeded(true);
        ignoreUnsavedChangesRef.current = false;
      }, 150);
    };

    setTimeout(() => {
      try {
        const previewImg = (stageRef.current as any).toDataURL({
          mimeType: "image/png",
          quality: 1,
          pixelRatio: 3,
        });

        const mediaPromise = postMedia(
          previewImg,
          `nets_preview_${Date.now()}.png`,
          `nets ${Date.now()}`
        );

        mediaPromise
          .then((res) => {
            if (!res.data) {
              handleSaveFailure(t("save net image retry", { ns: "tool" }));
              return;
            }

            const standardExist = standardShapes.find((nItem) => {
              const stanWidthPartitions = calculate_partitions(
                nItem.x_gap,
                nItem.x_length,
                nItem.x_diameter.steel_diameter
              );
              const stanHeigthPartitions = calculate_partitions(
                nItem.y_gap,
                nItem.y_length,
                nItem.y_diameter.steel_diameter
              );

              return (
                nItem.x_length === shapeObj.x_length &&
                nItem.y_length === shapeObj.y_length &&
                nItem.x_diameter.steel_diameter ===
                  shapeObj.x_diameter.steel_diameter &&
                nItem.y_diameter.steel_diameter ===
                  shapeObj.y_diameter.steel_diameter &&
                nItem.x_gap === shapeObj.x_gap &&
                nItem.y_gap === shapeObj.y_gap &&
                stanWidthPartitions._1 === partitionX._1 &&
                stanWidthPartitions._2 === partitionX._2 &&
                stanWidthPartitions._3 === partitionX._3 &&
                stanHeigthPartitions._1 === partitionY._1 &&
                stanHeigthPartitions._2 === partitionY._2 &&
                stanHeigthPartitions._3 === partitionY._3
              );
            });

            let newNetShape = {
              ...shapeObj,
              x_2: parseInt(partitionX._2),
              x_3: parseInt(partitionX._3),
              y_2: parseInt(partitionY._2),
              y_3: parseInt(partitionY._3),
              tool_number: netNum,
              preview_image: res.data.id,
              x_diameter: shapeObj.x_diameter.id,
              y_diameter: shapeObj.y_diameter.id,
              standard_net: Boolean(standardExist),
            };

            const deleteKeys = ["created", "last_modified"];

            if (edit) {
              if (newNetShape.name === "") {
                newNetShape = {
                  ...newNetShape,
                  name: null,
                };
              }

              deleteKeys.forEach((key: string) => delete newNetShape[key]);

              dispatch(updateNet(selectedTool.id, newNetShape, orderItem, rememberSavedItem))
                .then((result: any) => {
                  if (result?.error) {
                    handleSaveFailure(t("save net retry", { ns: "tool" }));
                    return;
                  }

                  dispatch(fetchLastUsedNets());
                  completeSuccessfulSave();
                })
                .catch(() => {
                  handleSaveFailure(t("save net retry", { ns: "tool" }));
                });

              return;
            }

            newNetShape = {
              ...newNetShape,
              type: 1,
              reference_tool: shapeObj.id,
            };

            deleteKeys.push("id");
            deleteKeys.forEach((key: string) => delete newNetShape[key]);

            dispatch(
              createNet(
                newNetShape,
                orderItem,
                rememberSavedItem,
                0,
                order.order_id
              )
            )
              .then((result: any) => {
                if (result?.error) {
                  handleSaveFailure(t("save net retry", { ns: "tool" }));
                  return;
                }

                dispatch(
                  setCurrentOrderNetsCount(currentOrderNetsCount + 1)
                );
                dispatch(fetchLastUsedNets());
                completeSuccessfulSave();
              })
              .catch(() => {
                handleSaveFailure(t("save net retry", { ns: "tool" }));
              });
          })
          .catch(() => {
            handleSaveFailure(t("save net image retry", { ns: "tool" }));
          });
      } catch (_error) {
        handleSaveFailure(t("create net image retry", { ns: "tool" }));
      }
    }, 100);
  }


  const getDiameter = (steelDiameterID: number) => {
    return steelDiameters[shapeObj.steel_type]?.find(
      (item: any) => item.id === steelDiameterID
    );
  };

  const setDefaultShape = async () => {
    setSelectedTool({ id: 0 });
    setSelectedShape(-1);
    setEditTool(false);
    setErrorsText([]);
    setShape({});
    let shapeInstance = {};
    const defaultDimensions = stanShapes[0];
    const defaultNet = standardShapes.find(isUsableNetCatalogShape);
    if (!defaultDimensions?.dia?.length || !defaultDimensions?.gaps?.length || !defaultNet) {
      addError({
        errorType: "INVALID_NET_DATA",
        message: t("invalid net data", { ns: "tool" }),
      });
      setIsLoading(false);
      return;
    }

    setShapes(stanShapes);
    setStanGaps(defaultDimensions.gaps);
    setStanDiams(defaultDimensions.dia);

    const initialDiam =
      defaultDimensions.dia.find((el) => el.steel_diameter === 8) ||
      defaultDimensions.dia[0];
    const initialGap =
      defaultDimensions.gaps.find((el) => el === 20) ||
      defaultDimensions.gaps[0];
    setFilterDiameter(initialDiam);
    setFilterGap(initialGap);
    shapeInstance = {
      ...defaultNet,
      standard_net: true,
      x_length: parseInt(defaultDimensions.lens.x),
      y_length: parseInt(defaultDimensions.lens.y),
      x_diameter: initialDiam,
      y_diameter: initialDiam,
      x_gap: parseInt(initialGap),
      y_gap: parseInt(initialGap),
      x_2: null,
      x_3: null,
      y_2: null,
      y_3: null,
    };
    setOrderItem({
      quantity: 0,
      production_notes: "",
      position_notes: "",
      row_number: 0,
    });
    await setInitialShape(shapeInstance);
    setShape({ ...shapeInstance });
  };

  return (
    <>
      {isBrowser && (
        <>
          <SideBar tab={tab} setTab={setTab} edit={edit}>
            <NetSideBar
              customizeView={customizeView}
              toggleUniformGap={toggleUniformGap}
              toggleUniformDiameter={toggleUniformDiameter}
              selectedShape={selectedShape}
              setSelectedShape={handleSetSelectedShape}
              filterDiameter={filterDiameter}
              setFilterDiameter={handleSetFilterDiameter}
              filterGap={filterGap}
              setFilterGap={handleSetFilterGap}
              edit={edit}
              partitionX={partitionX}
              partitionY={partitionY}
              setPartitionX={handleSetPartitionX}
              setPartitionY={handleSetPartitionY}
              shapeObj={shapeObj}
              setShape={handleSetShape}
              getDiameter={getDiameter}
              lastUsedShapes={lastUsedShapes}
              shapes={shapes}
              stanGaps={stanGaps}
              setStanGaps={setStanGaps}
              stanDiams={stanDiams}
              setStanDiams={setStanDiams}
              errorsText={errorsText}
              addError={addError}
              removeError={removeError}
              orderItem={orderItem}
              setOrderItem={handleSetOrderItem}
              onX1Change={onX1Change}
              onX2Change={onX2Change}
              onX3Change={onX3Change}
              onY1Change={onY1Change}
              onY2Change={onY2Change}
              onY3Change={onY3Change}
              isSaving={isSaving}
              saveNet={saveNet}
              checkLengths={checkLengths}
              finishButtonRef={finishButtonRef}
              addButtonRef={addButtonRef}
              setIsShapesError={setIsShapesError}
              isShapesError={isShapesError}
              showStandard={showStandard}
              setShowStandard={handleSetShowStandard}
              edgeChanged_X={edgeChanged_X}
              setEdgeChanged_X={handleSetEdgeChangedX}
              edgeChanged_Y={edgeChanged_Y}
              setEdgeChanged_Y={handleSetEdgeChangedY}
              initiateImage={initiateImage}
            />
          </SideBar>
          {/* <Content
            customizeView={customizeView}
            partitionX={partitionX}
            partitionY={partitionY}
            setPartitionX={handleSetPartitionX}
            setPartitionY={handleSetPartitionY}
            shapeObj={shapeObj}
            setShape={handleSetShape}
            labelingPoints={labelingPoints}
            setLabelingPoints={setLabelingPoints}
            resacleFactor={resacleFactor}
            setRescaleFactor={setRescaleFactor}
            isSaving={isSaving}
              saveNet={saveNet}
            orderItem={orderItem}
            setOrderItem={handleSetOrderItem}
            getDiameter={getDiameter}
            stageRef={stageRef}
            setErrorText={setErrorText}
            errorText={errorText}
            validateVals={validateVals}
            validateMidVals={validateMidVals}
            onX1Change={onX1Change}
            onX2Change={onX2Change}
            onX3Change={onX3Change}
            onY1Change={onY1Change}
            onY2Change={onY2Change}
            onY3Change={onY3Change}
            setNetNumber={handleSetNetNumber}
            edit={edit}
            setSelectedShape={handleSetSelectedShape}
          /> */}
          <SketchBody>
            <NetShape
              isLoading={isLoading}
              shapeObj={shapeObj}
              setRescaleFactor={setRescaleFactor}
              partitionX={partitionX}
              setPartitionX={handleSetPartitionX}
              partitionY={partitionY}
              setPartitionY={handleSetPartitionY}
              labelingPoints={labelingPoints}
              setLabelingPoints={setLabelingPoints}
              setShape={handleSetShape}
              stageRef={stageRef}
              customizeView={customizeView}
              setXUnits={setXUnits}
              setYUnits={setYUnits}
              errorsText={errorsText}
              addError={addError}
              removeError={removeError}
              validateVals={validateVals}
              validateMidVals={validateMidVals}
              onX1Change={onX1Change}
              onX2Change={onX2Change}
              onX3Change={onX3Change}
              onY1Change={onY1Change}
              onY2Change={onY2Change}
              onY3Change={onY3Change}
              checkLengths={checkLengths}
              showStandard={showStandard}
              setShowStandard={handleSetShowStandard}
              edgeChanged_X={edgeChanged_X}
              setEdgeChanged_X={handleSetEdgeChangedX}
              edgeChanged_Y={edgeChanged_Y}
              setEdgeChanged_Y={handleSetEdgeChangedY}
              initiateImage={initiateImage}
            />
          </SketchBody>
          <LastAddedSidebar
            dataLength={netsData.length}
            hasMore={hasMore}
            setHasMore={setHasMore}
            toolData={netsData}
            setToolData={setNetsData}
            checkRowNums={checkRowNums}
            editOrderId={editOrderId}
            editMode={editMode}
            saveTool={saveNet}
            shapeObj={shapeObj}
            edit={edit}
            finishButtonRef={finishButtonRef}
            addButtonRef={addButtonRef}
            isShapesError={isShapesError}
            setDefaultShape={setDefaultShape}
            handleClose={requestClose}
            editToolId={editToolId}
          >
            {/* Render last added rebars here */}
            <div
              className="card__list hoveredItems"
              style={editToolId >= 0 ? { marginTop: "40px" } : {}}
            >
              {netsData.map((item, index) => (
                <NetsCard
                  key={item.id}
                  id={item.id}
                  item={item.tool}
                  orderItem={item}
                  index={index}
                  deleteTool={deleteTool}
                  copyOrderItem={copyOrderItem}
                  setEditTool={setEditTool}
                  setSelectedTool={setSelectedTool}
                  setSelectedShape={handleSetSelectedShape}
                  selectedShape={selectedShape}
                  setErrorsText={setErrorsText}
                  setInProgress={setInProgress}
                  inProgress={inProgress}
                  editToolId={editToolId}
                  edit={edit}
                />
              ))}
            </div>
          </LastAddedSidebar>
        </>
      )}
      {isMobile && (
        <NetMobileContent
          edit={edit}
          shapeObj={shapeObj}
          setRescaleFactor={setRescaleFactor}
          partitionX={partitionX}
          setPartitionX={handleSetPartitionX}
          partitionY={partitionY}
          setPartitionY={handleSetPartitionY}
          labelingPoints={labelingPoints}
          setLabelingPoints={setLabelingPoints}
          setShape={handleSetShape}
          orderItem={orderItem}
          setOrderItem={handleSetOrderItem}
          stageRef={stageRef}
          filterDiameter={filterDiameter}
          setFilterDiameter={handleSetFilterDiameter}
          filterGap={filterGap}
          setFilterGap={handleSetFilterGap}
          selectedShape={selectedShape}
          setSelectedShape={handleSetSelectedShape}
          standardShapes={standardShapes}
          getDiameter={getDiameter}
          isLoading={isLoading}
          customizeView={customizeView}
          setXUnits={setXUnits}
          setYUnits={setYUnits}
          errorsText={errorsText}
          addError={addError}
          removeError={removeError}
          validateVals={validateVals}
          validateMidVals={validateMidVals}
          onX1Change={onX1Change}
          onX2Change={onX2Change}
          onX3Change={onX3Change}
          onY1Change={onY1Change}
          onY2Change={onY2Change}
          onY3Change={onY3Change}
          checkLengths={checkLengths}
          showStandard={showStandard}
          setShowStandard={handleSetShowStandard}
          toggleUniformGap={toggleUniformGap}
          toggleUniformDiameter={toggleUniformDiameter}
          edgeChanged_X={edgeChanged_X}
          setEdgeChanged_X={handleSetEdgeChangedX}
          edgeChanged_Y={edgeChanged_Y}
          setEdgeChanged_Y={handleSetEdgeChangedY}
          initiateImage={initiateImage}
          isSaving={isSaving}
              saveNet={() => saveNet(false, edit ? shapeObj.tool_number : currentOrderNetsCount + 1)}
          netNumber={edit ? shapeObj.tool_number : currentOrderNetsCount + 1}
          setNetNumber={handleSetNetNumber}
        />
      )}

      <Modal
        show={showUnsavedWarning}
        onHide={continueEditing}
        centered
        backdrop="static"
        keyboard={false}
        dir={rightToLeft ? "rtl" : "ltr"}
        dialogClassName="unsaved-warning-modal"
      >
        <Modal.Header>
          <Modal.Title>{t("notice", { ns: "tool" })}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="unsaved-warning-modal__body">
            <div className="unsaved-warning-modal__icon">!</div>

            <div>
              <strong>{t("unsaved changes", { ns: "tool" })}</strong>
              <p>{t("unsaved item message", { ns: "tool" })}</p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unsaved-warning-modal__continue"
            onClick={continueEditing}
          >
            {t("continue editing", { ns: "tool" })}
          </Button>

          <Button
            className="unsaved-warning-modal__discard"
            onClick={discardChangesAndClose}
          >
            {t("discard changes", { ns: "tool" })}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
  show={showSaveErrorModal}
  onHide={() => setShowSaveErrorModal(false)}
  centered
  backdrop="static"
  keyboard={false}
  dir={rightToLeft ? "rtl" : "ltr"}
  dialogClassName="unsaved-warning-modal"
>
  <Modal.Header>
    <Modal.Title>{t("save net failed", { ns: "tool" })}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="unsaved-warning-modal__body">
      <div className="unsaved-warning-modal__icon">!</div>

      <div>
        <strong>{t("could not save item", { ns: "tool" })}</strong>

        <p>
          {saveErrorMessage ||
            t("save retry message", { ns: "tool" })}
        </p>
      </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      className="unsaved-warning-modal__continue"
      onClick={() => setShowSaveErrorModal(false)}
    >
      {t("understood", { ns: "tool" })}
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
}

export default Net;